import state from "./state";

export const SET_USER_ID = (state, id) => {
    state.user_id = id
}

export const SET_USER_NAME = (state, name) => {
    state.user_name = name
}

export const SET_COMPANY_ID = (state, id) => {
    state.company_id = id
}

export const SET_COMPANY_NAME = (state, name) => {
    state.company_name = name
}

export const SET_PRIMARY_COLOR = (state, color) => {
    state.primary_color = color
}

export const SET_IS_POWER_USER = (state, is_power_user) => {
    state.is_power_user = is_power_user
}

export const SET_USER_TIMEZONE = (state, time_zone) => {
    state.time_zone = time_zone
}

export const SET_USER_PERMISSIONS = (state, permissions) => {
    state.permissions = permissions
}

export const SET_NOTIFICATIONS_PREFERENCES = (state, preference) => {
    state.notifications_preferences = preference
}

export const SET_COMPANY_TIER = (state, tier) => {
    state.tier = tier
}

export const SET_COMPANY_TIER_STATUS = (state, status) => {
    state.tierStatus = status
}

export const SET_TIER_LOADING = (state, status) => {
    state.tier_loading = status
}